import { render, staticRenderFns } from "./TableWatermeters.vue?vue&type=template&id=3080438f&"
import script from "./TableWatermeters.vue?vue&type=script&lang=js&"
export * from "./TableWatermeters.vue?vue&type=script&lang=js&"
import style0 from "./TableWatermeters.vue?vue&type=style&index=0&id=3080438f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports